import styled from 'styled-components';
import { Text } from 'shrike';

export const StyledText = styled(Text)`
  span {
    font-family: ${props => props.theme.fontFamilies.main.medium};
  }
`;
